<header class="topbar">
  <pec-search-panel />
  <div class="topbar-right">
    <!--@if (showAiBadge) {
      <span class="env-pill">
        <span class="env-dot"></span>
        AI Engine Online
      </span>
    }-->
    <button class="icon-btn" (click)="state.resetDemo()" matTooltip="Refresh">
      <mat-icon>refresh</mat-icon>
    </button>

  </div>
</header>
